import { render, staticRenderFns } from "./PayrollTypeNew.vue?vue&type=template&id=5e780393"
import script from "./PayrollTypeNew.vue?vue&type=script&lang=js"
export * from "./PayrollTypeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports